import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const badges = [
  { label: "WCAG 2.2 AA" },
  { label: "SEBI Circular Compliant" },
  { label: "AI Accessibility Testing" },
  { label: "Enterprise WCAG Solutions" },
];

const HeroSection = () => (
  <section className="relative pt-28 md:pt-[9rem] pb-12 section-padding overflow-hidden" aria-labelledby="hero-heading">
    <div className="absolute inset-0 opacity-[0.03]" aria-hidden="true" style={{ backgroundImage: "radial-gradient(circle at 1px 1px, hsl(var(--foreground)) 1px, transparent 0)", backgroundSize: "40px 40px" }} />

    <div className="relative max-w-7xl mx-auto animate-fade-up">
      <p className="eyebrow mb-6" data-tts-skip>
        <span><abbr title="International Association of Accessibility Professionals">IAAP</abbr> <abbr title="Certified Professional in Accessibility Core Competencies">CPACC</abbr> Certified</span>
      </p>
      <h1 id="hero-heading" className="font-display text-4xl md:text-5xl lg:text-[3.6rem] font-extrabold leading-[1.05] text-foreground mb-6 max-w-3xl">
        Web Accessibility Audit to{" "}
        <span className="text-primary"><abbr title="Web Content Accessibility Guidelines">WCAG</abbr> Compliance</span>
      </h1>
      <p className="text-lg md:text-xl text-muted-foreground leading-relaxed mb-10 max-w-xl">
        We audit websites, mobile apps and PDFs against <abbr title="Web Content Accessibility Guidelines">WCAG</abbr> 2.2 and Indian standards, then help you fix what we find.
      </p>
      <div className="flex flex-col sm:flex-row gap-3">
        <Button variant="hero" size="lg" className="min-h-[44px]" asChild>
          <a href="#contact">Schedule Audit <ArrowRight aria-hidden="true" /></a>
        </Button>
        <Button variant="hero-outline" size="lg" className="min-h-[44px]" asChild>
          <a href="#services">View Services</a>
        </Button>
      </div>

      {/* Trust credentials (skipped by Read Page — see extractReadableText) */}
      <div className="mt-14 border-t pt-6" role="list" aria-label="Trust credentials" data-tts-skip>
        <div className="flex flex-wrap gap-y-2 sm:divide-x">
          {badges.map((b) => (
            <span key={b.label} className="flex items-center pr-6 text-sm font-medium text-foreground sm:px-6 sm:first:pl-0" role="listitem">
              {b.label}
            </span>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default HeroSection;
